module.exports = __webpack_public_path__ + "static/media/ball.46bb1024.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/_assets/sound/ball.mp3
// module id = 181
// module chunks = 0